import React from "react";

import {
  Login
} from "../component/index";

const SignIn = () => {
  return (
    <>
      <div className="body_wrap">
        <Login />
      </div>
    </>
  );
};

export default SignIn;